/**
 * 简体中文
 */
var zhCN = {
  locale: 'zh-CH',
  Common: {
    pleaseInput: '请输入',
    pleaseSelect: '请选择',
    confirm: '确定',
    clear: '清除',
    cancel: '取消',
    next: '下一步',
    previous: '上一步',
    submit: '提交',
    reset: '重置'
  },
  Exception: {
    emptyData: '暂无数据',
    error: '页面发生错误，请稍后重试',
    networkError: '网络异常'
  },
  List: {
    noMoreData: '没有更多数据了',
    networkError: '网络异常',
    clickRetry: '点击重试'
  },
  DateRangePicker: {
    startTime: '开始时间',
    endTime: '结束时间',
    timeRange: '时间范围'
  }
};

export { zhCN as default };
